<script>
import Title from '@components/section-title'
import store from '@state/store'
import con from '@services/connection'
import { removeAccents } from '@utils/Format'
import Vue from 'vue'
import { MODAL, RELOAD } from '@constants/Text'
import { minhaCarteira } from '@constants/URL'
import { GlobalBus } from '@services/bus'
import { formatBrokerCode } from '@utils/cliente-codigo/cliente-codigo'
import { emailDoCliente } from '@utils/clienteEmail'

export default {
  components: {
    Title,
  },
  props: {
    bus: {
      type: Object,
      default: null,
      required: true,
    },
    title: {
      type: String,
      default: 'Selecionar cliente',
    },
    subtitle: {
      type: String,
      default: null,
    },
    openOnSelect: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      client: {},
      busModal: new Vue(),
      data: null,
      global: false,
    }
  },
  computed: {
    clientes() {
      return store.getters['user/allClients'] || []
    },
    usuarioAtual() {
      return store.getters['user/currentUser'] || {}
    },
  },
  watch: {
    usuarioAtual() {
      this.setClientes()
    },
  },
  created() {
    if (this.bus) {
      this.bus.$on(MODAL.SELECIONAR_CLIENTE, (v, a, global_bus) => {
        if (global_bus) {
          this.global = global_bus
        }
        if (!this.clientes || this.clientes.length === 0) {
          this.setClientes()
        }
        this.data = a
        if (v) {
          this.open_after = v
        }
        const clienteAtual = this.$store.getters['user/currentClient']
        if (clienteAtual && (clienteAtual.id || clienteAtual.nome_cliente)) {
          this.client = clienteAtual
          this.selecionar()
          return
        }

        if (this.usuarioAtual.IS_CLIENTE) {
          this.bus.$emit(this.open_after || this.open_on_select, this.client)
        } else {
          this.busModal.$emit('dialog', !!v)
        }
      })
    }
    GlobalBus.$on(RELOAD.CLIENTS, this.setClientes)
  },
  beforeDestroy() {
    GlobalBus.$off(RELOAD.CLIENTS, this.setClientes)
  },
  methods: {
    // Regra em `@utils/clienteEmail`. Não pré-compute `:items`: com
    // `return-object`, `selecionar()` passaria a emitir a CÓPIA mapeada.
    emailDoCliente,
    setClientes() {
      if (this.usuarioAtual.IS_CLIENTE) {
        return
      }
      con.post(minhaCarteira.listar_clientes).then((r) => {
        if (r.status === 200) {
          const lista = (r.value || [])
            .sort((a, b) => {
              return ('' + a.nome_cliente).localeCompare(b.nome_cliente)
            })
            .map((v, i) => {
              return {
                ...v,
                id: v.id || (v.id_cadastro_cliente || i) * -1,
                id_cadastro_cliente: v.id_cadastro_cliente,
                name: v.nome_cliente || '',
                login: v.login || '',
                id_cliente_web: v.id_cliente_web,
              }
            })
          store.dispatch('user/setClients', lista)
        }
      })
    },
    search() {},
    openNewClient() {
      GlobalBus.$emit(MODAL.CADASTRAR_CLIENTES, true)
    },
    selecionar() {
      if (this.client && this.client.id > 0) {
        this.bus.$emit('cliente_selecionado', this.client)
        if (this.open_after || this.open_on_select) {
          const router = this.open_after || this.open_on_select
          if (router.includes('abrir_pagina_')) {
            if (this.data && this.data.select_cliente) {
              store.dispatch('user/addSearchClient', this.client)
            }
            if (this.$route.name !== router.replace('abrir_pagina_', '')) {
              this.$router.push({
                name: router.replace('abrir_pagina_', ''),
                params: { ...this.data, cliente: this.client },
              })
            }
            this.busModal.$emit('dialog', false)
            this.client = {}
            return
          }

          this.busModal.$emit('dialog', false)
          if (this.global) {
            GlobalBus.$emit(
              this.open_after || this.open_on_select,
              this.client,
              this.data
            )
          } else {
            this.bus.$emit(
              this.open_after || this.open_on_select,
              this.client,
              this.data
            )
          }

          this.client = {}
        }
      } else if (
        this.client &&
        (this.client.id < 0 ||
          (!this.client.id && this.client.id_cadastro_cliente))
      ) {
        this.$showSnack({
          text: 'Você ainda não tem acesso a esse cliente',
          button: true,
        })
        this.client = {}
        if (this.$refs.campo) {
          this.$refs.campo.blur()
        }
        this.$refs.campo.reset()
      } else {
        this.$showSnack({
          text: 'Selecione um cliente',
          button: true,
        })
        this.client = {}
        if (this.$refs.campo) {
          this.$refs.campo.blur()
        }
        this.$refs.campo.reset()
      }
    },
    customFilter(item, queryText, itemText) {
      const name = removeAccents((item.name || '').toLowerCase())
      // `emailDoCliente` preserva a caixa (exibe `CLI_42` como está no banco);
      // quem compara é a busca, então ela baixa a caixa dos dois lados.
      const email = emailDoCliente(item).toLowerCase()
      const codigoCorretora = formatBrokerCode(item.codigo_corretora).toLowerCase()
      const searchText = removeAccents((queryText || '').toLowerCase())

      return (
        name.indexOf(searchText) > -1 ||
        email.indexOf(searchText) > -1 ||
        codigoCorretora.indexOf(searchText) > -1
      )
    },
  },
}
</script>

<template>
  <BaseModal content-class="no-overflow-x" :bus="busModal">
    <div>
      <Title :title="title" :subtitle="subtitle" />

      <v-row class="justify-content-center">
        <v-col cols="8">
          <div v-if="clientes.length > 0">
            <v-autocomplete
              ref="campo"
              v-model="client"
              :items="clientes"
              class="short-search align-icon-search no-border"
              filled
              item-value="id"
              item-text="name"
              label=""
              autocomplete="off"
              return-object
              full-width
              autofocus
              placeholder="Pesquisar outro cliente"
              :filter="customFilter"
              style="max-width: 300px"
              dense
              hide-details
              @change="search"
            >
              <template v-slot:append>
                <v-icon style="color: inherit; margin-top: -2px">
                  mdi-magnify
                </v-icon>
              </template>
              <template v-slot:item="{ item }">
                <v-list-item-content style="display: table-column">
                  <v-row style="padding: 5px; align-items: center">
                    <v-icon
                      v-if="!item.id_cadastro_cliente"
                      small
                      right
                      color="primary"
                    >
                      mdi-account
                    </v-icon>
                    <v-icon v-else small right> mdi-account-switch </v-icon>
                    <p style="margin-bottom: 0px; margin-left: 5px">
                      {{ item.name }}
                    </p>
                  </v-row>
                  <v-row>
                    <small style="margin-left: 15px" class="text-secondary">
                      {{ emailDoCliente(item) }}
                    </small>
                  </v-row>
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </div>
          <div
            v-else
            class="align-items-center justify-content-center d-flex"
            style="flex-direction: column"
          >
            <p> Nenhum cliente encontrado </p>
            <BaseButton primary @click="openNewClient">
              <strong>+</strong> Cliente
            </BaseButton>
          </div>
        </v-col>
      </v-row>
    </div>
    <template v-slot:actions="{ close }">
      <v-spacer />
      <BaseButton underlined @click="close"> Cancelar </BaseButton>
      <BaseButton primary @click="selecionar"> Selecionar </BaseButton>
      <v-spacer />
    </template>
  </BaseModal>
</template>

<!-- Era `scope` (typo): atributo inexistente, entao este bloco vazava para o
     documento inteiro. Scopar nao muda pixel nenhum — os unicos consumidores
     de `.costumer-search*` sao `short-search.vue` (raiz com `v-if="false"`) e
     `nav-bar.vue`, e os dois importam esta mesma folha no proprio bloco de
     estilo. O input daqui usa `.short-search`, definido no bloco global de
     `short-search.vue`, que continua global de proposito. -->
<style lang="sass" scoped>
@import '@design/components/_costumer-search.sass'
</style>
